(() => {
  'use strict';

  document.addEventListener('DOMContentLoaded', () => {
    const btn  = document.getElementById('js-load-more');
    const grid = document.getElementById('js-archive-grid');
    if (!btn || !grid) return;

    // 初期表示が空ならボタン非表示
    if (!grid.childElementCount) {
      btn.style.display = 'none';
      return;
    }
    // サーバ判定で「続きなし」なら非表示
    const initialHasMore = (btn.dataset.hasMore || '').trim();
    if (initialHasMore === '0') {
      btn.style.display = 'none';
      return;
    }

    // dataset を grid/btn からいい感じに拾うヘルパ
    const pick = (name) => (btn.dataset[name] || grid.dataset[name] || '').trim();

    // ===== パラメータ =====
    const ppp        = parseInt(btn.dataset.ppp || '9', 10); // ppp はボタン側から
    const postType   = pick('postType') || 'post';
    const taxonomy   = pick('taxonomy');                    // 単一タクソ用
    const termId     = parseInt(pick('termId') || '0', 10); // 単一タクソ用

    // 後方互換（cat/tag）
    const cat        = parseInt(btn.dataset.cat || '0', 10);
    const tag        = (btn.dataset.tag || '').trim();

    // multi（複数カテゴリ/タグの OR 条件）
    const taxMode    = pick('taxMode');     // "multi" なら multi ルート
    const catIds     = pick('catIds');      // "1,2,3"
    const tagIds     = pick('tagIds');      // "4,5"

    // 除外など
    const exclude    = pick('exclude');                          // "1,2,3"
    const baseOffset = parseInt(pick('baseOffset') || '0', 10);  // 例: 初期で6件描画済みなら 6
    const variant    = pick('variant') || (postType === 'voice' ? 'voice' : 'column');

    // offset 方式なら 1 から、通常なら 2 から（初回1ページ目は表示済み前提）
    let paged = parseInt(btn.dataset.paged || (baseOffset > 0 ? '1' : '2'), 10);

    // ===== UI helpers =====
    let loading = false;
    const setLoading = (flag) => {
      loading = flag;
      btn.classList.toggle('is-loading', flag);
      btn.setAttribute('aria-busy', flag ? 'true' : 'false');
      btn.disabled = !!flag;
    };

    btn.addEventListener('keydown', (e) => {
      if ((e.key === 'Enter' || e.key === ' ') && !loading) {
        e.preventDefault();
        btn.click();
      }
    });

    // ===== クリック =====
    btn.addEventListener('click', () => {
      if (loading) return;
      setLoading(true);

      const data = new FormData();
      data.append('action',      'bm_load_more');
      data.append('nonce',       (window.BM_LOADMORE && BM_LOADMORE.nonce) || '');
      data.append('paged',       String(paged));
      data.append('ppp',         String(ppp));
      data.append('post_type',   postType);
      data.append('variant',     variant);
      data.append('exclude',     exclude);
      data.append('base_offset', String(baseOffset));

      // ★ ここが肝心：multi なら cat_ids / tag_ids を投げる
      if (taxMode === 'multi') {
        data.append('tax_mode', 'multi');
        if (catIds) data.append('cat_ids', catIds);
        if (tagIds) data.append('tag_ids', tagIds);
      } else {
        // 単一タクソ or 後方互換
        if (taxonomy && termId) {
          data.append('taxonomy', taxonomy);
          data.append('term_id',  String(termId));
        } else {
          if (cat) data.append('cat', String(cat));
          if (tag) data.append('tag', tag);
        }
      }

      const ajaxUrl = (window.BM_LOADMORE && BM_LOADMORE.ajax_url) || '/wp-admin/admin-ajax.php';

      fetch(ajaxUrl, {
        method: 'POST',
        body: data,
        credentials: 'same-origin',
      })
        .then((r) => {
          if (!r.ok) throw new Error(`HTTP ${r.status}`);
          return r.json();
        })
        .then((res) => {
          if (res && res.html) {
            grid.insertAdjacentHTML('beforeend', res.html);
          }
          if (res && res.has_more) {
            paged += 1;
          } else {
            btn.style.display = 'none';
          }
        })
        .catch((err) => {
          console.error('[LOAD MORE] failed:', err);
        })
        .finally(() => setLoading(false));
    });
  });
})();
